/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from "../../router";
import state from "../state";
import store from "../store";
import { generateRandomNumber, calculateCheckDigit } from "../helpers";

export default {
	// Lists for role start
	listStockForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId");
		if (token === null || token == "null") {
		} else
			return new Promise((resolve, reject) => {
				/*	if (userJson.type == "fullfilment") {
						dispatch("listStockAll").then(response => {
							resolve(response);
						})
					} else {*/
				if (
					state.AppActiveUser.ROLE == "Owner" ||
					state.AppActiveUser.ROLE == "Admin"
				) {
					dispatch("listStockAll").then(response => {
						resolve(response);
					});
				} else if (state.AppActiveUser.ROLE == "Company")
					dispatch("listStockForCompany", state.AppActiveUser.companyid).then(
						response => {
							resolve(response);
						}
					);
				//}
			});
	},
	listStockTransForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId");
		if (token === null || token == "null") {
		} else
			return new Promise((resolve, reject) => {
				if (
					state.AppActiveUser.ROLE == "Owner" ||
					state.AppActiveUser.ROLE == "Admin"
				) {
					dispatch("listStockTrans", item).then(response => {
						resolve(response);
					});
				} else if (state.AppActiveUser.ROLE == "Company") {
					item.companyId = state.AppActiveUser.companyid;
					dispatch("listStockTransForCompany", item).then(response => {
						resolve(response);
					});
				}
			});
	},
	listStockTransAllForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId");
		if (token === null || token == "null") {
		} else
			return new Promise((resolve, reject) => {
				if (
					state.AppActiveUser.ROLE == "Owner" ||
					state.AppActiveUser.ROLE == "Admin"
				) {
					dispatch("listStockTransItem", item).then(response => {
						resolve(response);
					});
				} else if (state.AppActiveUser.ROLE == "Company") {
					item.companyId = state.AppActiveUser.companyid;
					dispatch("listStockTransItemForCompany", item).then(response => {
						resolve(response);
					});
				}
			});
	},
	// Lists for role end

	// Stock set-up start
	updateStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/stocks", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("UPDATE_ITEM_STOCK", item);
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					console.log(err);
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	addStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stocks", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOCK", item);
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	addStockList({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stocks/list", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					console.log(err);
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	pullStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/MarketPalce/pull/products/" +
					item.companyInfoId +
					"/" +
					item.depotId,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	listStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/stocks", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						commit("STOCK_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockForFilter({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stock/search/param?depotId=" +
					item.depotId +
					"&param=" +
					item.param,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						commit("STOCK_LIST", []);
					}
					resolve(err.response);
				});
		});
	},

	listStockAll({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/stocks/all", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/Stock/list/stocks/company/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						commit("STOCK_LIST", []);

						router.push("/login");
					}
				})
				.catch(err => {
					commit("STOCK_LIST", []);

					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/stocks/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOCK", item);
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	// Stock set-up end
	// Stock-barcode set-up start
	addStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stockbarcodes", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/Stock/update/stockbarcodes",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockBarcodes({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/stockbarcodes", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_BARCODES_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockWithBarcodes({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stockbarcode/onstock/company/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_BARCODE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						commit("STOCK_BARCODE_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockBarcodesForStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stockbarcode/stock/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_BARCODES_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockBarcodesForStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Depot/list/stockbarcode/depot/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_BARCODES_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					commit("STOCK_BARCODES_LIST", []);

					resolve(err.response);
				});
		});
	},
	listStockBarcodesForBarcode({ state, commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stockbarcode/stock/barcode/" +
					item.barcode +
					"/" +
					item.depotId,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						let itemLocal = {};
						if (response.data.message == "Stock list by master barcode") {
							let items = JSON.parse(response.data.json);
							itemLocal = { title: item, value: items[0] };
						} else {
							itemLocal = {
								title: item,
								value: JSON.parse(response.data.json)
							};
						}
						/*	if (response.data.message == "Stock list by master barcode") {
						} else {
							commit("ADD_ACCEPTED_BARCODES", itemLocal);
	
						}*/

						if (itemLocal.value.SerialFollow == true) {
							try {
								let objSeri = [];
								for (let index = 0; index < itemLocal.title.quantity; index++) {
									let baseCode = generateRandomNumber(12);
									let checkDigit = calculateCheckDigit(baseCode);

									objSeri.push({
										value: baseCode + checkDigit,
										status: true,
										serialStatus: true,
										currentPrice: itemLocal.title.isExcel
											? itemLocal.title.serialParam.currentPrice
												? itemLocal.title.serialParam.currentPrice
												: 0
											: 0,
										localCurrentPrice: itemLocal.title.isExcel
											? itemLocal.title.serialParam.localCurrentPrice
												? itemLocal.title.serialParam.localCurrentPrice
												: 0
											: 0,
										localCurrentCode: itemLocal.title.isExcel
											? itemLocal.title.serialParam.localCurrentCode
												? itemLocal.title.serialParam.localCurrentCode
												: "TL"
											: "TL",
										currentPriceCode: itemLocal.title.isExcel
											? itemLocal.title.serialParam.currentPriceCode
												? itemLocal.title.serialParam.currentPriceCode
												: ""
											: "",
										sellerCurrentCode: itemLocal.title.isExcel
											? itemLocal.title.serialParam.sellerCurrentCode
												? itemLocal.title.serialParam.sellerCurrentCode
												: ""
											: "",
										sellerPrice: itemLocal.title.isExcel
											? itemLocal.title.serialParam.sellerPrice
												? itemLocal.title.serialParam.sellerPrice
												: 0
											: 0
									});
								}
								itemLocal.title.serials = objSeri;
								commit("ADD_ACCEPTED_BARCODES", itemLocal);
							} catch (error) {
								console.log(error);
							}
						} else { 
							commit("ADD_ACCEPTED_BARCODES", itemLocal);
						}

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					console.log(err);
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress + "api/uzumservice/Stock/delete/stockbrcodes/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	// Stock-barcode set-up end
	//Stock Serial Number set-up start
	addStockSerialNumber({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stockserial", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockSerialNumber({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/stockserial", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	updateStockNewSerialNumber({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/stocktrans/serial?serial=" + item.serial + "&newSerial=" + item.newSerial, {}, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockSerialNumbers({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/stockserial", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_SERIAL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockSerialNumbersForStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stockserial/stock/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_SERIAL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					console.log(err);
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockSerialNumbersForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stockserial/company/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						//					commit("STOCK_SERIAL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStockSerialNumber({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress + "api/uzumservice/Stock/delete/stockserial/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStockSerialImage({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/Stock/add/stockserialimage",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token,
							"Content-Type": "multipart/form-data",
							accept: "*/*"
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStockSerialImageForSerial({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/Stock/list/stockserialimage/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	deleteStockSerialImage({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/Stock/delete/stockserialimage/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockSerialProperties({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/MarketPalce/update/marketplace/product/banayeni/prop",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	addStockSerialProperties({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/MarketPalce/add/marketplace/products/banayeni/prop", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStockSerialProperties({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/MarketPalce/list/marketplace/product/banayeni/prop/serial/" + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listBanayeniTagLists({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + 'api/uzumservice/MarketPalce/list/marketplace/products/banayeni/tags/' + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("BANAYENI_TAGS_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	//Stock Serial Number set-up end
	// Stock-trans set-up start
	listStockTransForStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans/company/transtype?startDate=" + item.startDate + "&endDate=" + item.endDate + "&stockId=" +
					item.stockId +
					"&companyId=" +
					item.companyId,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_DETAIL_LIST", item);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					console.log(err)
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					console.log(err.response.data.message)
					if (err.response.data.message.includes("stok hareketi listelenemiyor"))
						commit("STOCK_TRANS_DETAIL_LIST", []);

					resolve(err.response);
				});
		});
	},
	listStockTransItem({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans?startDate=" +
					item.startDate +
					"&endDate=" +
					item.endDate,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_ALL_ITEM_LIST", item);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockTransItemForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans/company/" +
					item.companyId,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_ALL_ITEM_LIST", item);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockTransDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans/detail?code=" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_DETAIL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockTransForType({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans?startDate=" +
					item.startDate +
					"&endDate=" +
					item.endDate,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_ALL_TYPES", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},

	listStockTrans({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans/head?startDate=" +
					item.startDate +
					"&endDate=" +
					item.endDate,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_ALL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockTransForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktrans/company?companyId=" +
					item.companyId,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_ALL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//	commit("STOCK_TRANS_ALL_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockTransType({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/stocktranstype", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = response.data;
						commit("STOCK_TRANS_TYPE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},

	listStockTransForDepot({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"fullfilment/api/uzumservice/Stock/list/stocktrans/" +
					item.depotId +
					"?startDate=" +
					item.startDate +
					"&endDate=" +
					item.endDate,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TRANS_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	addStockTrans({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/Stock/add/stocktrans/list",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						//	commit("REMOVE_ACCEPTED_ALL_BARCODES")
					}

					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	// Stock-trans set-up end
	//Stock-trans price set-up start
	updateStockTransPrice({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/Stock/update/stocktransprice",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStockTransPrice({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/Stock/delete/stocktransprice/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStockTransPriceByTransId({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/list/stocktransprice/serial?serial=" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	//Stock-trans price set-up end
	//Stock-matches set-up start
	listStockMatching({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/Stock/list/barcodematching/barcodes",
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockMatchingAll({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/barcodematching", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	addStockMatching({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/Stock/add/barcodeMatching",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockMatching({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/Stock/update/barcodematching",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStockMatching({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/Stock/delete/barcodematching/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	//Stock-matches set-up end

	//Stock-taking set-up start
	listStockTaking({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/Stock/list/stocktaking?done=" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TAKING_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (
						err.response.status == 400 &&
						err.response.data.message.includes("not list")
					) {
						commit("STOCK_TAKING_LIST", []);
						resolve(response.data);
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	addStockTaking({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stocktaking", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	doneStockTaking({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/done/stocktaking", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					},
					params: {
						depotId: item.depotId,
						companyId: item.companyId,
						type: item.type
					}
				})
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	againStockTaking({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/Stock/again/stocktakingitem/" +
					item.StockTakingItemId +
					"?barcode=" +
					item.ReadBarcode,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						},
						params: {
							depotId: item.depotId,
							companyId: item.companyId,
							type: item.type
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStockTakingItem({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/Stock/add/stocktakingitem",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStockTakingItemForId({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/Stock/list/stocktakingitem/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_TAKING_ITEM");
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	deleteStockTaking({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress + "api/uzumservice/Stock/delete/stocktaking/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	//Stock-taking set-up end
	//Stock-bundle set-up start
	addStockBundle({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/Stock/add/bundleproduct/list",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockBundle({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/Stock/update/bundleproduct",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	listStockBundle({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		commit("STOCK_BUNDLE_LIST", []);

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list/bundleproduct", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	listStockBundleByCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/Stock/list?id=" + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("STOCK_BUNDLE_LIST", []);

					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_BUNDLE_LIST", item);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
						//		commit("STOCK_TRANS_LIST", []);
					}
					resolve(err.response);
				});
		});
	},
	deleteStockBundle({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress + "api/uzumservice/Stock/delete/bundleproduct/" + item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	//Stock-bundle set-up end
	//Stock-expertize set-up start
	addProductExpertizeImage({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/CheckList/add/productexpertiseimage",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token,
							"Content-Type": "multipart/form-data",
							accept: "*/*"
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listProductExpertizeImageForSerial({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/CheckList/list/productexpertiseimage/serial?serial=" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);

						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	deleteProductExpertizeImage({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/productexpertiseimage/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addProductExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/CheckList/add/productexpertisehead",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					let expertizeHead = JSON.parse(response.data.json);
					commit("PRODUCT_EXPERTIZE_HEAD", expertizeHead);
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listProductExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/CheckList/list/productexpertisehead",
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("PRODUCT_EXPERTIZE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	updateProductExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress +
					"api/uzumservice/CheckList/update/productexpertisehead",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteProductExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/productexpertisehead/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addProductExpertizeItem({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/CheckList/add/productexpertise",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listProductExpertizeItem({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress + "api/uzumservice/CheckList/list/productexpertise",
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("PRODUCT_EXPERTIZE_ITEM_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	listProductExpertizeItemForHead({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/CheckList/list/productexpertise/headid/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						//	commit("PRODUCT_ITEM_EXPERTIZE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	updateProductExpertizeItem({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/CheckList/update/productexpertise",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteProductExpertizeItem({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/productexpertise/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},

	listExpertizeShemaProperty({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(
					sistemAddress +
					"api/uzumservice/CheckList/list/checklistshemaproperty/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	addExpertizeShemaProperty({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress +
					"api/uzumservice/CheckList/add/checklistshemaproperty",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateExpertizeShemaProperty({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress +
					"api/uzumservice/CheckList/update/checklistshemaproperty",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteExpertizeShemaProperty({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/checklistshemaproperty/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listExpertizeShema({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/CheckList/list/checklistshema", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_EXPERTIZE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	addExpertizeShema({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/CheckList/add/checklistshema",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateExpertizeShema({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/CheckList/update/checklistshema",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteExpertizeShema({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/checklistshema/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStockProductGroupForExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}

		return new Promise((resolve, reject) => {
			axios
				.get(sistemAddress + "api/uzumservice/CheckList/list/productgroup", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCK_GROUP_EXPERTIZE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login");
					}
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					} else if (err.response.status == 400) {
					}
					resolve(err.response);
				});
		});
	},
	addStockProductGroupForExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;

		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.post(
					sistemAddress + "api/uzumservice/CheckList/add/productgroup",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockProductGroupForExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/CheckList/update/productgroup",
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login");
					}
					resolve(err.response);
				});
		});
	},
	deleteStockProductGroupForExpertize({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId");
		if (!token) {
			store.dispatch("auth/logout");
			router.push("/login");
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(
					sistemAddress +
					"api/uzumservice/CheckList/delete/productgroup/" +
					item,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	}
	//Stock-expertize set-up start
};
